<div class="filter-buttons-container">
  <div class="buttons-background button-position vertical-align-buttons">
    <ng-content></ng-content>
  </div>
</div>
